export const getGradientForRun = (runId) => {
    const hues = [185, 200, 220, 340, 45, 300];
    const index = runId
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0) % hues.length;
    const hue = hues[index];
  
    let hash = 0;
    for (let i = 0; i < runId.length; i++) {
      hash = ((hash << 5) - hash) + runId.charCodeAt(i);
      hash |= 0;
    }
  
    const lightness1 = 60 + Math.abs(hash % 10);
    const lightness2 = 45 + Math.abs((hash * 7) % 10);
  
    return `linear-gradient(135deg, hsl(${hue}, 35%, ${lightness1}%), hsl(${hue}, 30%, ${lightness2}%))`;
  };